export default {
  en: {
    'top-nav.link.account-settings': 'Account settings',
    'top-nav.link.sign-out': 'Sign out',
    'top-nav.link.messages': 'Messages',
    'top-nav.link.notes': 'Notes',
    'top-nav.link.profile': 'Profile',
    'top-nav.link.dashboard': 'Dashboard',
    'top-nav.link.settings': 'Settings',
  },
};
